import { AppState } from 'src';
import { Dispatch, connect } from 'react-redux';
import { VendorDetailsComponent, VendorDetailsComponentProperties } from './vendor-details.component';
import {
  getVendorDetails,
  getVendorFiles,
  saveVendorFiles,
  removeVendorFile,
  setVendorFilesLoading,
  saveVendor
} from 'src/vendor/vendor.actions';
import { clearVendor } from '../../vendor.actions';
import { FileViewModel } from '@models/Document';
import { VendorViewModel } from '@models/Vendor';

function mapStateToProps(state: AppState, ownProps: {}): Partial<VendorDetailsComponentProperties> {
  return {
    vendorVM: state.vendor.vendorVM,
    documents: state.vendor.documents
  };
}

function mapDispatchToProps(dispatch: Dispatch<AppState>, ownProps: {}): Partial<VendorDetailsComponentProperties> {
  return {
    getVendorDetails: (vendorId: number) => {
      return dispatch(getVendorDetails(vendorId)).then(() => {
        dispatch(getVendorFiles(vendorId));
      });
    },
    clearVendor: () => {
      dispatch(clearVendor());
    },
    uploadFiles: (vendorId: number, fileVMs: FileViewModel[], vendor: VendorViewModel) => {
      dispatch(setVendorFilesLoading(true));
      dispatch(saveVendorFiles(vendorId, fileVMs))
        .then(() => dispatch(saveVendor(vendor)))
        .then(() => {
          dispatch(getVendorFiles(vendorId)).then(() => {
            dispatch(setVendorFilesLoading(false));
          });
        });
    },
    removeFile: (vendorId: number, fileId: number, vendor: VendorViewModel) => {
      dispatch(setVendorFilesLoading(true));
      dispatch(removeVendorFile(vendorId, fileId))
        .then(() => dispatch(saveVendor(vendor)))
        .then(() => {
          dispatch(getVendorFiles(vendorId)).then(() => {
            dispatch(setVendorFilesLoading(false));
          });
        });
    },
    convertVendor: (model: VendorViewModel) => {
      dispatch(saveVendor(model));
    }
  };
}

export const VendorDetails = connect(
  mapStateToProps,
  mapDispatchToProps
)(VendorDetailsComponent);



// WEBPACK FOOTER //
// ./src/vendor/_components/vendor-details/vendor-details.container.ts